__turbopack_context__.v({
  "contentHomepage": "bYxW9a_contentHomepage",
  "topPadding": "bYxW9a_topPadding",
  "zeroMargin": "bYxW9a_zeroMargin",
});
